import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import { LANDING } from "@/constants/landingTestIds";

const LegalLayout = ({ title, lastUpdated, testId, children }) => {
  return (
    <div className="min-h-screen bg-white font-body" data-testid={testId}>
      <Navbar />

      <main className="pt-32 pb-24 px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <Link
            to="/"
            data-testid={LANDING.legalBackHomeBtn}
            className="inline-flex items-center gap-2 text-sm font-semibold text-[#2563EB] hover:text-[#1D4ED8] transition-colors mb-10 group"
          >
            <ArrowLeft className="w-4 h-4 transition-transform group-hover:-translate-x-1" />
            Back to Home
          </Link>

          <h1 className="font-heading text-4xl sm:text-5xl font-bold text-[#0F172A] tracking-tight mb-3">
            {title}
          </h1>
          <p className="text-sm text-slate-500 mb-12">Last updated: {lastUpdated}</p>

          <article className="space-y-10">{children}</article>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export const LegalSection = ({ title, children }) => (
  <section>
    <h2 className="font-heading text-xl sm:text-2xl font-bold text-[#0F172A] mb-3">
      {title}
    </h2>
    <div className="space-y-3 text-slate-600 leading-relaxed text-base [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1.5 [&_li]:leading-relaxed [&_strong]:text-[#0F172A] [&_strong]:font-semibold [&_a]:text-[#2563EB] [&_a]:font-medium">
      {children}
    </div>
  </section>
);

export default LegalLayout;
